import { Box, Typography, Button } from "@mui/material";
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import AddIcon from '@mui/icons-material/Add';
import { useState, useEffect } from "react";
import CustomAxios from "../utils/CustomAxios";
import { CustomDeductionForm } from "../components/CustomDeductionForm";
import { CustomDeductionTable } from "../components/CustomDeductionTable";

export function CustomDeduction() {
    const [showForm, setShowForm] = useState(false);
    const [banks, setBanks] = useState([]);

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await CustomAxios.get('oasis/form_details/');
                setBanks(response.data.bankName || []);
            } catch (error) {
                console.error('Error fetching form details:', error);
            }
        };
        fetchOptions();
    }, []);

    // Create bank list like in Receipts module
    const bankList = banks.filter((data) => data.bankname !== null).map((filteredData) => filteredData.bankname);

    return (
        <Box className="fulldiv" style={{ width: "100%", height: "calc(100vh - 40px)", marginTop: "40px" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", height: { sm: 'initial', padding: "0px 20px 0px 20px" }, width: "100%" }}>
                {/* Header */}
                <Box sx={{ width: "100%", top: "72px", left: "304px", padding: "8px 0px 8px 0px", display: "flex", justifyContent: "space-between", borderBottom: "1px solid #CBD5E1", alignItems: "center", height: "84px" }}>
                    <Box sx={{ height: "48px", padding: "8px 0px 8px 0px", gap: "12px", display: "flex", alignItems: "center" }}>
                        <Box sx={{ width: "32px", height: "32px" }}>
                            <PriceChangeOutlinedIcon sx={{ width: "32px", height: "32px", color: "#288d2c" }} />
                        </Box>
                        <Typography sx={{ fontFamily: "inter", fontSize: "20px", fontWeight: "600", lineHeight: "28px", color: "#242424" }}>Custom Deduction</Typography>
                    </Box>
                    {!showForm && (
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={() => setShowForm(true)}
                            sx={{
                                background: "#288d2c",
                                textTransform: "none",
                                height: "40px",
                                padding: "8px 16px",
                                fontFamily: "inter",
                                fontSize: "16px",
                                fontWeight: "400",
                                "&:hover": {
                                    background: "#1f6d22"
                                }
                            }}
                        >
                            New Deduction
                        </Button>
                    )}
                </Box>

                {/* Content Section */}
                {showForm ? (
                    <CustomDeductionForm 
                        bankList={bankList}
                        onBack={() => setShowForm(false)}
                    />
                ) : (
                    <CustomDeductionTable />
                )}
            </Box>
        </Box>
    );
}
